import React from 'react';
import { motion } from 'framer-motion';
export function ShameClinicSection() {
  return <section className="w-full bg-navy py-14 md:py-[88px] px-6" data-id="element-176">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-[680px] mx-auto text-center flex flex-col items-center" data-id="element-177">
        <h2 className="text-3xl md:text-[36px] font-serif italic text-white leading-[1.3]" data-id="element-178">
          La mayoría estamos fingiendo.
          <br data-id="element-179" />
          Tú no eres el único.
        </h2>

        <div className="w-14 h-[2px] bg-gold my-7" data-id="element-180"></div>

        <p className="text-[17px] font-sans text-[#C8D8E8] leading-[1.85]" data-id="element-181">
          Mecánicos, maestras, contadores, ingenieros, abuelas, gerentes — todos
          admitimos en privado que no entendemos la Inteligencia Artificial.
          Asentimos. Sonreímos. Cambiamos el tema. Y esa misma noche, solos
          frente a la pantalla, no sabemos ni por dónde empezar.
        </p>

        <p className="text-[17px] font-sans text-[#C8D8E8] leading-[1.85] mt-6" data-id="element-182">
          No es ignorancia. Es falta de compañía en el momento correcto.
        </p>

        <p className="text-base font-sans italic text-gold mt-6" data-id="element-183">
          Este libro existe para esa persona. Para ti.
        </p>
      </motion.div>
    </section>;
}